import React, { Component } from 'react';
import './style.scss';

export class Resizable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onResize = (event) => {
    const { left, top } = this.resizableRef.getBoundingClientRect();
    const newHeight = `${event.clientY - top}px`;
    const newWidth = `${event.clientX - left}px`;
    this.props.onResize({
      heightPx: newHeight,
      widthPx: newWidth,
      height: parseInt(newHeight, 10),
      width: parseInt(newWidth, 10),
    });
    event.preventDefault();
    event.stopPropagation();
  };

  onResizeEnd = (event) => {
    document.removeEventListener('mousemove', this.onResize);
    document.onmouseup = this.onResizeEnd;
    event.preventDefault();
    event.stopPropagation();
  };

  onResizeStart = (event) => {
    document.addEventListener('mousemove', this.onResize);
    document.onmouseup = this.onResizeEnd;
    event.preventDefault();
    event.stopPropagation();
  };

  componentDidMount() {
    this.dragger.addEventListener('mousedown', this.onResizeStart);
  }

  componentWillUnmount() {
    document.removeEventListener('mousemove', this.onResize);
    document.removeEventListener('mouseup', this.onResizeEnd);
    this.dragger.removeEventListener('mousedown', this.onResizeStart);
  }

  render() {
    const { key, isEditable, children } = this.props;
    return (
      <div
        key={key}
        className={`resizable ${!isEditable ? 'hidden' : ''}`}
        ref={(ref) => {
          this.resizableRef = ref;
        }}>
        {children}
        <div
          className={'dragger'}
          ref={(ref) => {
            this.dragger = ref;
          }}
        />
      </div>
    );
  }
}
